//Flickity Slider
import Flickity from 'flickity';
import 'flickity-imagesloaded/flickity-imagesloaded';
import { fullWidthCarousel } from './blocks/full-width-carousel';

import { heroCarousel } from './blocks/hero-carousel';

import Alpine from 'alpinejs'

window.Alpine = Alpine


heroCarousel();
fullWidthCarousel();

// document.addEventListener("DOMContentLoaded", function () {

// });
